import { useRef } from 'react';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, IconName, Stack, TextInput, TextInputProps } from '@optimus-web/core';
import { copyInputToClipboard } from '@mews-commander/utils';

export const CopyableInput = (props: TextInputProps) => {
    const ref = useRef<HTMLElement>(null);

    const handleCopy = () => copyInputToClipboard(ref.current?.getAttribute('value') || '');

    return (
        <Stack fill spacing="100" itemAlignment="end">
            <Stack fill distribution="stretch">
                <TextInput size="medium" {...props} ref={ref} />
            </Stack>
            <Button size="medium" type="button" icon={IconName.Copy} onClick={handleCopy}>
                <LocalizedText textKey={TextKey.Copy} />
            </Button>
        </Stack>
    );
};
